import { Button ,Form, FloatingLabel, } from "react-bootstrap"
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar } from "@mui/x-data-grid";


const OneInvoice = () =>{    

    // Previously Processed inovice
    const column = [
     
        {
            field: "Select",
            headerName: "Select",
            sortable: false,
            width: 200,
            disableClickEventBubbling: true,
            renderCell: (data) => {
          
      
              return (
                <>
                  <>
                    <div className="action_btn">
                      <div className="floating-checbox">
                                    <div className="form-check form-check-inline">
                                      <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="CWT" name="RateType" />
                                      <label className="form-check-label" htmlFor="inlineCheckbox1"></label>
                                    </div>
                                  </div>
                    </div>
                  </>
                </>
              )
      
            },
          },
        { field: "Batch", headerName: "Batch", width: 200 },
        { field: "Cycle", headerName: "Cycle", width: 200 },
        { field: "Invoicedate", headerName: "Invoicedate", width: 200 },
        { field: "Process", headerName: "Process", width: 200 },
        { field: "Start", headerName: "Start", width: 200 },
        { field: "End", headerName: "End", width: 200 },
        { field: "Total", headerName: "Total", width: 200 }
    ];

    const row = [
        { id: 1, Batch: '20532', Cycle: 'Bombard', Invoicedate: "22/10/2022", Process: "01/11/2022", Start: "20/10/2023" , End: "20/10/2023", Total : "1450.00"},
    ];

    return(
        <>
        <div className="invoice-date">
        <FloatingLabel controlId="floatingInput" label="Select Customer" style={{marginRight:"10px"}}>
                    <Form.Select aria-label="Default select example">
                        <option>Select Customer</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </Form.Select>
                    </FloatingLabel>
             <Form.Group controlId="accountnumber" style={{marginRight:"10px"}}>
                        <FloatingLabel controlId="floatingInput" label="Start Invoice date">
                            <Form.Control type="date" placeholder="Account Name" name="AccountName" value="" />
                        </FloatingLabel>
                    </Form.Group>
                    <span className="to"> to </span>
                    <Form.Group controlId="accountnumber" style={{marginRight:"10px"}}>
                        <FloatingLabel controlId="floatingInput" label="Last Invoice date">
                            <Form.Control type="date" placeholder="Account Name" name="AccountName" value="" />
                        </FloatingLabel>
                    </Form.Group>
                    <div className="invoice-btn">
                    <Button>Create Invoice</Button>
                    </div>
        </div>
      {/* Previously Inovides */}
      <div className="user-role-table " style={{ height: "400px" }}>
        <h6>List of Previously processed & not posted inovice batches</h6>
        <DataGrid rows={row} columns={column} pageSize={10} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
      </div>
        </>
    )
}
export default OneInvoice